/**
 * Константы приложения (события из лингвы и прочее)
 */

export default Object.freeze({
  INTERACTION_STARTED: 'INTERACTION_STARTED',
  INTERACTION_STOPPED: 'INTERACTION_STOPPED',
  ROBOT_REPLIC_FINISH: 'ROBOT_REPLIC_FINISH',
  ROBOT_REPLIC_START: 'ROBOT_REPLIC_START',
  USER_REPLIC_FINISH: 'USER_REPLIC_FINISH',
  SCREEN_READY: 'SCREEN_READY',
  AUTH_TOKEN: 'AUTH_TOKEN',

  // Diff

  ACCOUNT_FIELD_LENGTH: 12,
  SEND_METER_MIN_DAY: 20,
  SEND_METER_MAX_DAY: 28,
  BAD_TEMPERATURE: 37.2,

  // Actions

  ACTION_VOLUME_UP: 'ACTION_VOLUME_UP',
  ACTION_VOLUME_DOWN: 'ACTION_VOLUME_DOWN',
  ACTION_GO_HOME: 'ACTION_GO_HOME',
  ACTION_GO_BACK: 'ACTION_GO_BACK',
  ACTION_RETRY: 'ACTION_RETRY',
  ACTION_SUBMIT: 'ACTION_SUBMIT',
  ACTION_AGREE: 'ACTION_AGREE',
  ACTION_DISAGREE: 'ACTION_DISAGREE',
  ACTION_CLOSE: 'ACTION_CLOSE',
  ACTION_CONTINUE: 'ACTION_CONTINUE',
  ACTION_BACK: 'ACTION_BACK',
  ACTION_REMAKE: 'ACTION_REMAKE',
  ACTION_PRINT: 'ACTION_PRINT',
  ACTION_CANCEL: 'ACTION_CANCEL',
  ACTION_PICK: 'ACTION_PICK',
  ACTION_PLAY: 'ACTION_PLAY',
  ACTION_MORE: 'ACTION_MORE',
  ACTION_ADD: 'ACTION_ADD',
  ACTION_PERSONAL: 'ACTION_PERSONAL',
  ACTION_SIGN_UP: 'ACTION_SIGN_UP',
  ACTION_SIGN_IN: 'ACTION_SIGN_IN',
  ACTION_SEND_METER: 'ACTION_SEND_METER',
  ACTION_ADD_FEEDBACK: 'ACTION_ADD_FEEDBACK',
  ACTION_TAKE_PHOTO: 'ACTION_TAKE_PHOTO',
  ACTION_SCAN_QR: 'ACTION_SCAN_QR',
  ACTION_EDIT_PROFILE: 'ACTION_EDIT_PROFILE',
  ACTION_SHOW_ACCOUNTS: 'ACTION_SHOW_ACCOUNTS',
  ACTION_PAY: 'ACTION_PAY',
  ACTION_LOGOUT: 'ACTION_LOGOUT',
  ACTION_ADD_ACCOUNT: 'ACTION_ADD_ACCOUNT',
  ACTION_FIND_ACCOUNT: 'ACTION_FIND_ACCOUNT',
  ACTION_RECORD_AUDIO: 'ACTION_RECORD_AUDIO',
  ACTION_RECORD_VIDEO: 'ACTION_RECORD_VIDEO',
  ACTION_SHOW_MODAL: 'ACTION_SHOW_MODAL',
  ACTION_SHOW_PHOTO_FRAMES: 'ACTION_SHOW_PHOTO_FRAMES',
  ACTION_SLIDE_PREV: 'ACTION_SLIDE_PREV',
  ACTION_SLIDE_NEXT: 'ACTION_SLIDE_NEXT',

  // STEPS

  STEP_START: 'STEP_START',
  STEP_CONNECTION_ERROR: 'STEP_CONNECTION_ERROR',
  STEP_HARDWARE_ERROR: 'STEP_HARDWARE_ERROR',
  STEP_NO_PAPER_ERROR: 'STEP_NO_PAPER_ERROR',
  STEP_MODAL: 'STEP_MODAL',
  STEP_LOGIN_MODAL: 'STEP_LOGIN_MODAL',
  STEP_EMAIL_MODAL: 'STEP_EMAIL_MODAL',
  STEP_PHONE_MODAL: 'STEP_PHONE_MODAL',
  STEP_COVID: 'STEP_COVID',
  STEP_HOME: 'STEP_HOME',
  STEP_FEEDBACK: 'STEP_FEEDBACK',
  STEP_AUDIO_INSTRUCTION: 'STEP_AUDIO_INSTRUCTION',
  STEP_VIDEO_INSTRUCTION: 'STEP_VIDEO_INSTRUCTION',
  STEP_AUDIO_READY: 'STEP_AUDIO_READY',
  STEP_VIDEO_READY: 'STEP_VIDEO_READY',
  STEP_SEND_AUDIO: 'STEP_SEND_AUDIO',
  STEP_SEND_VIDEO: 'STEP_SEND_VIDEO',
  STEP_FEEDBACK_SENDED: 'STEP_FEEDBACK_SENDED',
  STEP_TERMS_MODAL: 'STEP_TERMS_MODAL',
  STEP_TAKE_PHOTO: 'STEP_TAKE_PHOTO',
  STEP_PHOTO_READY: 'STEP_PHOTO_READY',
  STEP_SEND_PHOTO: 'STEP_SEND_PHOTO',
  STEP_PHOTO_SENDED: 'STEP_PHOTO_SENDED',
  STEP_PHOTO_PRINTED: 'STEP_PHOTO_PRINTED',
  STEP_SIGN_IN: 'STEP_SIGN_IN',
  STEP_LOGIN_INVALID: 'STEP_LOGIN_INVALID',
  STEP_PASSWORD_INVALID: 'STEP_PASSWORD_INVALID',
  STEP_SIGN_UP: 'STEP_SIGN_UP',
  STEP_LOGIN: 'STEP_LOGIN',
  STEP_LOGIN_ERROR: 'STEP_LOGIN_ERROR',
  STEP_EMAIL: 'STEP_EMAIL',
  STEP_EMAIL_ERROR: 'STEP_EMAIL_ERROR',
  STEP_PHONE: 'STEP_PHONE',
  STEP_PHONE_ERROR: 'STEP_PHONE_ERROR',
  STEP_FIELDS_READY: 'STEP_FIELDS_READY',
  STEP_REGISTRATION_READY: 'STEP_REGISTRATION_READY',
  STEP_REGISTRATION_SUCCESS: 'STEP_REGISTRATION_SUCCESS',
  STEP_PERSONAL: 'STEP_PERSONAL',
  STEP_CONFIRM_CREATE: 'STEP_CONFIRM_CREATE',
  STEP_PROFILE: 'STEP_PROFILE',
  STEP_PROFILE_UPDATED: 'STEP_PROFILE_UPDATED',
  STEP_UPDATE_FAILED: 'STEP_UPDATE_FAILED',
  STEP_CONFIRM_LEAVE: 'STEP_CONFIRM_LEAVE',
  STEP_ACCOUNTS: 'STEP_ACCOUNTS',
  STEP_ADD_ACCOUNT: 'STEP_ADD_ACCOUNT',
  STEP_FIND_ACCOUNT: 'STEP_FIND_ACCOUNT',
  STEP_ADD_FAILED: 'STEP_ADD_FAILED',
  STEP_BIND_FAILED: 'STEP_BIND_FAILED',
  STEP_ACCOUNT_ADDED: 'STEP_ACCOUNT_ADDED',
  STEP_SCAN_QR: 'STEP_SCAN_QR',
  STEP_SCAN_FAILED: 'STEP_SCAN_FAILED',
  STEP_SCAN_FINISH: 'STEP_SCAN_FINISH',
  STEP_QR_ERROR: 'STEP_QR_ERROR',
  STEP_ORDER: 'STEP_ORDER',
  STEP_CONFIRM_PAY: 'STEP_CONFIRM_PAY',
  STEP_PAY: 'STEP_PAY',
  STEP_PAY_ERROR: 'STEP_PAY_ERROR',
  STEP_PAY_SUCCESS: 'STEP_PAY_SUCCESS',
  STEP_BAD_DATE: 'STEP_BAD_DATE',
  STEP_GUEST_ACCOUNT: 'STEP_GUEST_ACCOUNT',
  STEP_SEND_METER: 'STEP_SEND_METER',
  STEP_CONFIRM_SEND: 'STEP_CONFIRM_SEND',
  STEP_METER_SENDED: 'STEP_METER_SENDED',
  STEP_SEND_FAILED: 'STEP_SEND_FAILED',
  STEP_BALANCE: 'STEP_BALANCE',
  STEP_TEMPERATURE: 'STEP_TEMPERATURE',
  STEP_BAD_TEMPERATURE: 'STEP_BAD_TEMPERATURE',
  STEP_GOOD_TEMPERATURE: 'STEP_GOOD_TEMPERATURE',
  STEP_MEET: 'STEP_MEET',
  STEP_FACE: 'STEP_FACE',
  STEP_FORM_ERROR: 'STEP_FORM_ERROR',
  STEP_METERS_EMPTY: 'STEP_METERS_EMPTY',
  STEP_SENDING_ERROR: 'STEP_SENDING_ERROR',
});
